import { cn } from "@/lib/utils";

/**
 * Progress bar. Replaces the inline-width div pattern in Usage.jsx.
 *
 * Usage:
 *   <Progress value={reportsUsed} max={maxReports} />
 *   <Progress value={aiUsed} max={maxAI} showLabel />
 */
function Progress({ value = 0, max = 100, showLabel = false, className }) {
  const pct = Math.min(Math.round((value / max) * 100), 100);
  const isDanger = pct >= 90;
  const isWarning = pct >= 70 && pct < 90;

  return (
    <div className={cn("space-y-1", className)}>
      {showLabel && (
        <div className="flex justify-between text-xs text-muted-foreground font-sans">
          <span>{value} used</span>
          <span
            className={cn(
              isDanger  && "text-destructive font-semibold",
              isWarning && "text-warning font-semibold"
            )}
          >
            {pct}%
          </span>
        </div>
      )}
      {/* Track */}
      <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
        {/* Fill */}
        <div
          className={cn(
            "h-full rounded-full transition-all duration-300",
            isDanger  ? "bg-destructive" :
            isWarning ? "bg-warning"     :
                        "bg-primary"
          )}
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={max}
        />
      </div>
    </div>
  );
}

export { Progress };
